import React, { cloneElement } from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import { Grid, TextField, Button } from '@material-ui/core';
import Utils from '../../providers/Utils';
import FromServer from './FromServer';
import Calendar from 'react-calendar';
import ProjectDateChange from '../../commons/dialogs/ProijectDateChange';
// import DatePicker from 'react-date-picker';
import LocalStorage from '../../providers/LocalStorage';
import ListEtapeAddProiect from './ListEtapeAddProiect';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import GanttProiectIntegral from '../../commons/GanttProiectIntegral';
import GanttProiecteCreateEtapeView from './GanttProiecteCreateEtapeView';
import ro from 'date-fns/locale/ro';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";


import { ReactComponent as Step1Green } from '../../Pics/iconsManagement/step1_green.svg';
import { ReactComponent as Step2Green } from '../../Pics/iconsManagement/step2_green.svg';
import { ReactComponent as Step3 } from '../../Pics/iconsManagement/step3.svg';
import { ReactComponent as Step4Gray } from '../../Pics/iconsManagement/step4_gray.svg';


registerLocale('ro', ro)


export default class AddEtapeProiectCards extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            proiect: null,
            windowWidth: 1000,
            isOpenAlert: false,
            isOpenAlert2: false,
            isOpenAlert3: false,
            etape: [],
            useriProiect: [],
            etapaSelectata: {
                id: null,
                denumire: null,
                id_user_responsabil: 0,
                note: null, // desccriere
                durata_de_la: new Utils().transformDataForSql(new Date()),
                durata_pana_la: new Utils().transformDataForSql(new Date()),
                cand_ora: '10:00',
                pana_cand_ora: '18:00'

            },
            dtStartDate: new Date(),
            dtFinishDate: new Date(),
            showCalendars: false,
            activeStep: 2,
            steps: [

                { id: 0, done: true, icon: <Step1Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoProiect' },
                { id: 1, done: false, icon: <Step2Green style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToUtilizatori' },
                { id: 2, done: false, icon: <Step3 style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoEtape' },
                { id: 3, done: false, icon: <Step4Gray style={{ width: 20, height: 20 }} className='new-project-icons' />, goTo: 'goToInfoBuget' }

            ],
            addEditEtapa: false
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.getWindowWidth)
        this.getInfoProiect()
    }

    getWindowWidth = () => {

        // console.log('window :', window.innerWidth);
        this.setState({ windowWidth: window.innerWidth })
    }


    getIcons = () => {



        return this.state.steps.map((s, idx) => {

            return (



                <div key={idx} style={{ display: 'inline-block' }} onClick={this.props[s.goTo]}>
                    {s.icon}

                </div>
            )
        })
    }


    insertEtapa = async (e) => {

        // console.log('e :', e);

        let utils = new Utils();
        let fS = new FromServer();
        let ls = new LocalStorage().GetUserData()

        console.log('ls :>> ', ls);


        let objToInsert = {
            id_proiect: this.state.proiect[0].id,
            denumire: this.state.etapaSelectata.denumire || '',
            durata_de_la: this.state.etapaSelectata.durata_de_la,
            durata_pana_la: this.state.etapaSelectata.durata_pana_la,
            id_user_responsabil: this.state.etapaSelectata.id_user_responsabil || 0,
            adaugata_de: ls.InfoUser.IdUser,
            adaugata_la: utils.defaultData(),
            cand_ora: this.state.etapaSelectata.cand_ora,
            pana_cand_ora: this.state.etapaSelectata.pana_cand_ora,
            note: this.state.etapaSelectata.note || '',

        }

        let objToUpdate = {
            id_proiect: this.state.proiect[0].id,
            denumire: this.state.etapaSelectata.denumire || '',
            durata_de_la: this.state.etapaSelectata.durata_de_la,
            durata_pana_la: this.state.etapaSelectata.durata_pana_la,
            id_user_responsabil: this.state.etapaSelectata.id_user_responsabil || 0,
            cand_ora: this.state.etapaSelectata.cand_ora,
            pana_cand_ora: this.state.etapaSelectata.pana_cand_ora,
            note: this.state.etapaSelectata.note || '',


        }


        console.log('objToInsert :>> ', objToInsert);

        console.log('objToUpdate :>> ', objToUpdate);
        if (!this.state.etapaSelectata.id) {

            console.log('insert :>> ',);

            let insertE = await fS.insertEtapa(objToInsert);

            if (insertE) {
                // console.log('insertOk :', insertE);

                this.setState({
                    etapaSelectata: {
                        id: null,
                        denumire: null,
                        id_user_responsabil: 0,
                        note: null, // desccriere
                        durata_de_la: this.state.etapaSelectata.durata_de_la,
                        durata_pana_la: this.state.etapaSelectata.durata_pana_la,
                        cand_ora: '10:00',
                        pana_cand_ora: '18:00',
                        windowWidth: window.innerWidth

                    }
                }, () => {
                    this.getInfoProiect()

                })
            }

        } else {

            console.log('update :>> ',);

            let updateE = await fS.updateEtapa(objToUpdate, this.state.etapaSelectata.id)

            if (updateE) {

                this.setState({
                    etapaSelectata: {
                        id: null,
                        denumire: null,
                        id_user_responsabil: 0,
                        note: null, // desccriere
                        durata_de_la: this.state.etapaSelectata.durata_de_la,
                        durata_pana_la: this.state.etapaSelectata.durata_pana_la,
                        cand_ora: '10:00',
                        pana_cand_ora: '18:00',
                        windowWidth: window.innerWidth

                    }
                }, () => {
                    this.getInfoProiect()

                })

            }
        }



        console.log('objToInsert :', objToInsert);


    }



    handleChange = nume => ev => {

        let cloneEtapa = { ...this.state.etapaSelectata }

        cloneEtapa[nume] = ev.target.value

        this.setState({ etapaSelectata: cloneEtapa })
    }

    getInfoProiect = async () => {

        let fS = new FromServer();

        let u = new Utils();

        let _getInfoProiect = await fS.getInfoProiect(this.props.idproiect);

        let _getEtapeProiect = await fS.getEtape(this.props.idproiect)

        let _getUseriProiect = await fS.getUsers(this.props.idproiect)

        let [getInfoProiect, getEtapeProiect, getUseriProiect] = await Promise.all([_getInfoProiect, _getEtapeProiect, _getUseriProiect])

        console.log('getInfoProiect :', getInfoProiect);

        console.log('getEtapeProiect :>> ', getEtapeProiect);


        let cloneProiect = getInfoProiect

        let cloneEtape = getEtapeProiect

        cloneProiect[0].perioada_dela = u.ParseDataFromSql(cloneProiect[0].perioada_dela)

        cloneProiect[0].perioada_panala = u.ParseDataFromSql(cloneProiect[0].perioada_panala)

        let listUsers = getUseriProiect


        let newUsers = []

        for (let i = 0, n = listUsers.length; i < n; i++) {
            let idx = newUsers.findIndex(u => u.id_linie === listUsers[i].id_linie)

            if (idx === -1) {
                newUsers.push(listUsers[i])
            }
        }


        for (let i = 0, n = cloneEtape.length; i < n; i++) {

            cloneEtape[i].taskuri = []
        }

        console.log('cloneEtape :>> ', cloneEtape);

        this.setState({
            proiect: cloneProiect,
            etape: cloneEtape,
            addEditEtapa: getEtapeProiect.length > 0 ? false : true,
            useriProiect: newUsers,
            dtStartDate: new Date(cloneProiect[0].perioada_dela),
            dtFinishDate: new Date(cloneProiect[0].perioada_panala)
        })


    }


    saveInformatii = async () => {


        let fS = new FromServer();
        let u = new Utils()

        let obj = {
            descriere: this.state.proiect.descriere || '',
            perioada_dela: u.transformDataForSql(this.state.dtStartDate),
            perioada_panala: u.transformDataForSql(this.state.dtFinishDate),
            titlu: this.state.proiect.titlu,
            beneficiar_proiect: this.state.proiect.beneficiar_proiect || '',
            cod_proiect: this.state.proiect.cod_proiect || ''
        }

        // console.log('obj :', obj);

        let save = await fS.saveInformatiiProiect(obj, this.props.idproiect)

        // console.log('save :', save);

        if (save.Succes) {
            this.props.goToUtilizatori()
        }

    }


    stergeProiect = async () => {
        let ws = new Ws();

        let deleteP = await ws.update('proiecte', { sters: 1 }, { id: this.props.idproiect })

        if (deleteP.Succes) {
            this.props.history.push('/projects')
        }
    }



    handleDate = (ev, name) => {
        // console.log('ev :', ev);
        // console.log('name :', name);



        let obj = { ...this.state.etapaSelectata }
        obj[name] = new Utils().transformDataForSql(ev)

        // console.log('obj :', obj);

        this.setState({ etapaSelectata: obj })


    }

    openUpdateEtapa = (e) => {

        this.setState({
            etapaSelectata: {
                id: e.id,
                denumire: e.denumire,
                id_user_responsabil: e.id_user_responsabil,
                note: e.note, // desccriere
                durata_de_la: e.durata_de_la,
                durata_pana_la: e.durata_pana_la,
                cand_ora: e.cand_ora,
                pana_cand_ora: e.pana_cand_ora,

            },
            addEditEtapa: true
        })
    }

    openInsertEtapa = () => {

        let cloneEtape = [...this.state.etape]

        let dataStart;
        let dataFinish;



        if (cloneEtape.length > 0) {

            dataStart = new Date(new Date(cloneEtape[cloneEtape.length - 1].durata_pana_la).setDate(new Date(cloneEtape[cloneEtape.length - 1].durata_pana_la).getDate() + 1))

            dataFinish = new Date(new Date(cloneEtape[cloneEtape.length - 1].durata_pana_la).setDate(new Date(cloneEtape[cloneEtape.length - 1].durata_pana_la).getDate() + 2))

        } else {
            dataStart = new Date()
            dataFinish = new Date(new Date().setDate(new Date().getDate() + 1))
        }




        console.log('dataStart :>> ',);
        console.log('dataFinish :>> ', dataFinish);
        this.setState({
            etapaSelectata: {
                id: null,
                denumire: null,
                id_user_responsabil: 0,
                note: null, // desccriere
                durata_de_la: new Utils().transformDataForSql(dataStart),
                durata_pana_la: new Utils().transformDataForSql(dataFinish),
                cand_ora: '10:00',
                pana_cand_ora: '18:00',

            },
            addEditEtapa: true
        })
    }


    deleteEtapa = async (e) => {



        let fs = new FromServer()

        let objUpdateEtapa = {
            inactiv: 1
        }

        let delEtapa = fs.updateEtapa(objUpdateEtapa, e.id)

        if (delEtapa) {
            this.getInfoProiect()
        }
    }

    dataStartChange = async (ev, name) => {

        // console.warn('info proiect--------- :', this.props.proiectInfo);
        console.warn('dataSTartChange :>> ',);
        let fs = new FromServer();

        let u = new Utils()


        // console.log('ev data start :', ev);

        let dataChanghed = ''

        let dataEv = new Date(ev)
        dataEv = new Date(dataEv.setDate(dataEv.getDate() + 1))

        // console.log('dataSTart :', this.props.proiectInfo[0]);
        console.log('new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_dela) :>> ', new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_dela)));
        console.log('ev :>> ', ev);
        console.log('dataEv :>> ', dataEv);






        if (new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_dela)) <= ev && ev <= new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_panala))) {
            // console.log('etapeList :', this.props.etape);


            if (this.state.etapaSelectata.id) {
                let idx = this.state.etape.findIndex(i => i.id === this.state.etapaSelectata.id)

                console.log('first if :>> ', idx);


                //  console.log('filterEtape :', filterEtape);




                let okToInsert = 0


                if (idx === 0) {
                    okToInsert = 0
                } else if (ev < new Date(this.state.etape[idx - 1].durata_de_la)) {
                    console.log('elseIF :>>  ', new Date(this.state.etape[idx - 1].durata_de_la));
                    console.log('ev :>> ', ev);

                    okToInsert = 1
                }


                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(filterEtape[i].durata_de_la) && ev < new Date(filterEtape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }


                console.log('object :>> ', this.state.etapaSelectata.durata_pana_la);
                console.log('ev :>> ', ev);


                if (ev < new Date(this.state.etapaSelectata.durata_pana_la)) {
                    okToInsert = 0
                } else {

                    okToInsert = 2
                }


                console.log('okToInsert :>> ', okToInsert);


                if (okToInsert === 1) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //       console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else if (okToInsert === 2) {
                    this.setState({
                        isOpenAlert2: true
                    })
                }


                else {
                    let obj = {
                        durata_de_la: u.transformDataForSql(ev)
                    }

                    //  console.log('obj :', obj);

                    let update = await fs.updateEtapa(obj, this.state.etapaSelectata.id)

                    if (update) {

                        let obj = { ...this.state.etapaSelectata }
                        obj[name] = new Utils().transformDataForSql(ev)


                        this.setState({
                            etapaSelectata: obj,


                        })

                    }
                }
            } else {
                let counter = this.state.etape.length

                let okToInsert = 0


                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(this.props.etape[i].durata_de_la) && ev < new Date(this.props.etape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }

                if(this.state.etape.length > 1){
                    if (ev < new Date(this.state.etape[this.state.etape.length - 1].durata_de_la)) {
                        // console.log('elseIF :>>  ', new Date(this.state.etape[idx - 1].durata_de_la));
                        console.log('ev :>> ', ev);
    
                        okToInsert = 1
                    }
                }


               


                if (ev < new Date(this.state.etapaSelectata.durata_pana_la)) {
                    okToInsert = 0
                } else {

                    okToInsert = 2
                }


                console.log('okToInsert :>> ', okToInsert);


                if (okToInsert === 1) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //       console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else if (okToInsert === 2) {
                    this.setState({
                        isOpenAlert2: true
                    })
                } else {


                    let obj = { ...this.state.etapaSelectata }
                    obj[name] = new Utils().transformDataForSql(ev)


                    this.setState({
                        etapaSelectata: obj,


                    })


                }
            }


        } else {


            this.setState({
                isOpenAlert: true
            }, () => {
                //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }



    dataFinishChange = async (ev, name) => {
        let fs = new FromServer();

        let u = new Utils()

        // console.log('ev data start :', ev);

        let dataChanghed = ''

        // console.log('dataSTart :', this.props.proiectInfo[0]);
        console.log('this.state.proiect[0].perioada_dela :>> ', this.state.proiect[0].perioada_panala);
        console.log('ev :>> ', new Date(u.transformDataForSql(ev)));


        if (new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_dela)) <= new Date(u.transformDataForSql(ev)) && new Date(u.transformDataForSql(ev)) <= new Date(u.ParseDataFromSql(this.state.proiect[0].perioada_panala))) {

            console.log('ev :>> ', ev);
            console.log('this.state.proiect :>> ', this.state.proiect);
            //    console.log('etapeList :', this.props.etape);

            if (this.state.etapaSelectata.id) {

                let idx = this.state.etape.findIndex(i => i.id === this.state.etapaSelectata.id)

                // let counter = filterEtape.length


                //    console.log('filterEtape :', filterEtape);

                let okToInsert = 0

                if (idx === 0) {
                    if (this.state.etape.length > 1) {
                        if (new Date(u.transformDataForSql(ev)) >= new Date(new Date(this.state.etape[idx + 1].durata_pana_la).setDate(new Date(this.state.etape[idx + 1].durata_pana_la).getDate() - 1))) {
                            okToInsert = 1
                        } else {
                            okToInsert = 0
                        }
                    } else {
                        okToInsert = 1
                    }

                } else if (new Date(u.transformDataForSql(ev)) < new Date(this.state.etape[idx - 1].durata_pana_la)) {
                    okToInsert = 1
                }


                if (new Date(u.transformDataForSql(ev)) > new Date(this.state.etapaSelectata.durata_de_la)) {
                    okToInsert = 0
                } else {

                    okToInsert = 2
                }

                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(filterEtape[i].durata_de_la) && ev < new Date(filterEtape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }




                if (okToInsert === 1) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else if (okToInsert === 2) {
                    this.setState({
                        isOpenAlert3: true
                    })
                } else {
                    let obj = {
                        durata_pana_la: u.transformDataForSql(ev)
                    }


                    let update = await fs.updateEtapa(obj, this.state.etapaSelectata.id)

                    if (update) {


                        let obj = { ...this.state.etapaSelectata }
                        obj[name] = new Utils().transformDataForSql(ev)


                        this.setState({
                            etapaSelectata: obj,


                        })

                    }
                }
            }
            else {
                let counter = this.state.etape.length

                let okToInsert = 0


                // for (let i = 0; i < counter; i++) {
                //     if (ev > new Date(this.props.etape[i].durata_de_la) && ev < new Date(this.props.etape[i].durata_pana_la)) {
                //         okToInsert += 1
                //     }
                // }





                if (new Date(u.transformDataForSql(ev)) > new Date(this.state.etapaSelectata.durata_de_la)) {
                    okToInsert = 0
                } else {

                    okToInsert = 2
                }


                console.log('okToInsert :>> ', okToInsert);


                if (okToInsert === 1) {
                    this.setState({
                        isOpenAlert: true
                    }, () => {
                        //       console.log('this.state.dtDataStart :', this.state.dtDataStart);
                    })
                } else if (okToInsert === 2) {
                    this.setState({
                        isOpenAlert2: true
                    })
                } else {


                    let obj = { ...this.state.etapaSelectata }
                    obj[name] = new Utils().transformDataForSql(ev)


                    this.setState({
                        etapaSelectata: obj,


                    })


                }





            }


        } else {


            this.setState({
                isOpenAlert: true
            }, () => {
                //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }



    changeViewEtape = (is, e) => {
        console.log('is :>> ', is);
        console.log('e :>> ', e);
    }


    goToTaskView = (t, e) => {
        console.log('t :>> ', t);
        console.log('e :>> ', e);
    }

    showTag = (e) => {
        // console.log('e :>> ', e);

        let cloneEtape = [...this.state.etape]

        let idx = cloneEtape.findIndex(et => et.id === e.id)

        if (idx !== -1) {
            cloneEtape[idx].show_tag = true

            this.setState({ etape: cloneEtape })
        }
    }


    hideTag = (e) => {
        // console.log('e :>> ', e);

        let cloneEtape = [...this.state.etape]

        let idx = cloneEtape.findIndex(et => et.id === e.id)

        if (idx !== -1) {
            cloneEtape[idx].show_tag = false

            this.setState({ etape: cloneEtape })
        }
    }

    showUserTag = (u) => {

        let cloneUseri = [...this.state.useri]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = true

            this.setState({ useri: cloneUseri })
        }

    }

    hideUserTag = (u) => {
        let cloneUseri = [...this.state.useri]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = false

            this.setState({ useri: cloneUseri })
        }
    }
    render() {
        return (
            <div>

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.alertDate.etapa}
                    limba={this.dictionary}
                    yesFunction={() => { this.setState({ isOpenAlert: false }) }}
                    noButtonDisplay={1}
                />

                <AlertDialog
                    open={this.state.isOpenAlert2}
                    dialogClose={() => { this.setState({ isOpenAlert2: false }) }}
                    title={this.dictionary.proiecte.alertDataEtapa}
                    limba={this.dictionary}
                    yesFunction={() => { this.setState({ isOpenAlert2: false }) }}
                    noButtonDisplay={1}
                />

                <AlertDialog
                    open={this.state.isOpenAlert3}
                    dialogClose={() => { this.setState({ isOpenAlert3: false }) }}
                    title={this.dictionary.proiecte.alertDataEtapaSfarsit}
                    limba={this.dictionary}
                    yesFunction={() => { this.setState({ isOpenAlert3: false }) }}
                    noButtonDisplay={1}
                />

                {this.state.addEditEtapa &&
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white' }}>


                        <div style={{ position: 'absolute', top: -20, left: 0, right: 0, margin: "auto" }}>
                            {this.getIcons()}
                        </div>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 0 }}>
                                {this.dictionary.proiecte.creeazaEtape}

                            </h4>

                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.proiect !== null &&
                                < div style={{ width: '90%', margin: 'auto' }}>

                                    <GanttProiecteCreateEtapeView
                                        objProiectInfo={this.state.proiect}
                                        dictionary={this.dictionary}
                                        listEtape={this.state.etape}
                                        screenLimit={this.state.windowWidth > 800 ? 30 : (this.state.windowWidth < 600 ? 6 : 12)}
                                        listTaskuri={[]}
                                        changeView={this.changeViewEtape}
                                        goToTask={this.goToTaskView}
                                        insertEtapa={() => { this.setState({ isOpenEtapaInsert: true }) }}
                                        listSubTaskuri={[]}
                                        useri={this.state.useriProiect}
                                        showTag={this.showTag}
                                        hideTag={this.hideTag}
                                        showUserTag={this.showUserTag}
                                        hideUserTag={this.hideUserTag}

                                    />
                                </div>
                            }
                        </Grid>
                        {this.state.proiect !== null &&

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <h5 style={{ textAlign: 'center', marginBottom: 40, fontWeight: 400, color: 'gray' }}> <span style={{ fontWeight: 600 }}> {this.dictionary.proiecte.perioadaProiectului}</span> {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_dela)} - {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_panala)}</h5>
                                {/* <h5 style={{ textAlign: 'center', marginBottom: 40, fontWeight: 400, color: 'gray' }}> <span style={{ fontWeight: 600 }}> blah</span> {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_dela)} - {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_panala)}</h5> */}
                          
                          
                            </Grid>
                        }





                        <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid container>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.denumireEtapa}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>

                                    <input
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='denumire'
                                        value={this.state.etapaSelectata.denumire || ""}
                                        onChange={this.handleChange('denumire')}
                                        placeholder={this.dictionary.proiecte.denumireEtapaPlaceholder}
                                    />


                                </Grid>

                                <Grid item style={{ textAlign: 'right' }}  xs={5} sm={5} md={5} lg={5} xl={5} >

                                    <select
                                        style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='id_user_responsabil'
                                        value={this.state.etapaSelectata.id_user_responsabil}
                                        onChange={this.handleChange('id_user_responsabil')}
                                        placeholder={this.dictionary.proiecte.selecteazaResponsabilEtapa}
                                    >
                                        <option value={0}>{this.dictionary.proiecte.selecteazaResponsabilEtapa}</option>

                                        {this.state.useriProiect.map((l, idx) => {
                                            return (
                                                <option key={idx} value={l.id}>{l.nume}</option>
                                            )
                                        })}

                                    </select>


                                </Grid>


                            </Grid>





                        </Grid>

                        <Grid style={{ textAlign: 'left', margin: 'auto', paddingLeft: 20, marginBottom: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.descriereEtapa}: </span>
                                    </div>

                                </Grid>

                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <textarea
                                        className='add-project-input'
                                        margin="normal"
                                        name='note'
                                        value={this.state.etapaSelectata.note || ""}
                                        onChange={this.handleChange('note')}
                                        style={{ minHeight: 100 }}
                                        placeholder={this.dictionary.proiecte.descriereEtapa}
                                    >

                                    </textarea>

                                </Grid>
                            </Grid>

                        </Grid>



                        <Grid style={{ textAlign: 'left', paddingLeft: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <Grid container>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <div style={{ position: 'relative', height: '100%' }}>
                                        <span style={{
                                            verticalAlign: 'sub',
                                            color: 'black',
                                            fontSize: 14
                                        }}>{this.dictionary.proiecte.dateEtapa}: </span>
                                    </div>

                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ width: '90%' }}>

                                        <DatePicker

                                            className='add-project-input'
                                            style={{ width: '100%' }}
                                            selected={this.state.etapaSelectata.durata_de_la ? new Date(this.state.etapaSelectata.durata_de_la) : new Date()}
                                            onChange={(ev) => { this.dataStartChange(ev, 'durata_de_la') }}
                                            startDate={new Date(this.state.etapaSelectata.durata_de_la)}
                                            shouldCloseOnSelect={true}
                                            calendarClassName="calendar-left-absolute"
                                            locale="ro"
                                            disabled={this.props.readOnly}
                                            dateFormat="dd/MM/yyyy"
                                            customInput={<div className='date-picker'>

                                                <span>


                                                    {this.state.etapaSelectata.durata_de_la}

                                                    {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                </span>

                                                <i style={{

                                                    fontSize: 18,
                                                    verticalAlign: 'middle'

                                                }} className='material-icons'>today</i>
                                            </div>}
                                            monthsShown={2}
                                        />
                                        {/* <DatePicker
                                            className='date-picker'
                                            style={{ width: '80%' }}
                                            name='durata_de_la'
                                            locale='ro'
                                            prevLabel='Data Inceput'
                                            value={this.state.etapaSelectata.durata_de_la ? new Date(this.state.etapaSelectata.durata_de_la) : new Date()}
                                            onChange={(ev) => { this.dataStartChange(ev, 'durata_de_la') }}
                                            calendarIcon={<i className='material-icons' style={{ fontSize: 18 }} >calendar_today</i>}
                                            clearIcon={null} /> */}
                                    </div>

                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <input
                                        style={{ width: '80%' }}
                                        className='add-project-input'
                                        type="time"
                                        margin="normal"
                                        name={'cand_ora'}
                                        value={this.state.etapaSelectata.cand_ora || ""}
                                        onChange={this.handleChange('cand_ora')}
                                        placeholder='Denumirea primei etape'
                                    />
                                </Grid>



                                <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <div style={{ width: '90%', display: 'inline-block' }}>

                                        <DatePicker

                                            className='add-project-input'
                                            style={{ width: '100%' }}
                                            selected={this.state.etapaSelectata.durata_pana_la ? new Date(this.state.etapaSelectata.durata_pana_la) : new Date()}
                                            onChange={(ev) => { this.dataFinishChange(ev, 'durata_pana_la') }}
                                            startDate={new Date(this.state.etapaSelectata.durata_pana_la)}
                                            shouldCloseOnSelect={true}
                                            calendarClassName="calendar-left-absolute"
                                            locale="ro"
                                            disabled={this.props.readOnly}
                                            dateFormat="dd/MM/yyyy"
                                            customInput={<div className='date-picker'>

                                                <span>


                                                    {this.state.etapaSelectata.durata_pana_la}

                                                    {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                </span>

                                                <i style={{

                                                    fontSize: 18,
                                                    verticalAlign: 'middle'

                                                }} className='material-icons'>today</i>
                                            </div>}
                                            monthsShown={2}
                                        />
                                        {/* <DatePicker
                                            className='date-picker'
                                            style={{ width: '80%' }}
                                            name='durata_pana_la'
                                            prevLabel='Data Sfarsit'
                                            locale='ro'
                                            value={this.state.etapaSelectata.durata_pana_la ? new Date(this.state.etapaSelectata.durata_pana_la) : new Date()}
                                            onChange={(ev) => { this.dataFinishChange(ev, 'durata_pana_la') }}
                                            calendarIcon={<i className='material-icons' style={{ fontSize: 18 }} >calendar_today</i>}
                                            clearIcon={null} /> */}

                                    </div>

                                </Grid>

                                <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <input
                                        style={{ width: '80%' }}
                                        className='add-project-input'
                                        type="time"
                                        margin="normal"
                                        name={'pana_cand_ora'}
                                        value={this.state.etapaSelectata.pana_cand_ora || ""}
                                        onChange={this.handleChange('pana_cand_ora')}
                                        placeholder='Denumirea primei etape'
                                    />
                                </Grid>
                            </Grid>

                            <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    </Grid>
                                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <Button
                                            style={{ backgroundColor: 'rgb(24 165 58 )' }}
                                            variant="contained"
                                            className='next-step-projects'
                                            color="primary" onClick={this.insertEtapa}>
                                            {this.dictionary.proiecte.salveazaEtapa}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>


                        </Grid>



                        {/* <Grid style={{ display: this.props.showSave ? 'none' : 'block', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                            <Button variant="outlined" className='pm-save-button' color="primary" onClick={this.saveInformatii}>
                                {this.dictionary.comune.save}
                            </Button>

                            <Button style={{ marginLeft: 10 }} variant="outlined" className='pm-delete-button' color="primary" onClick={this.stergeProiect}>
                                {this.dictionary.comune.sterge}
                            </Button>


                        </Grid> */}
                    </Grid>
                }


                {
                    !this.state.addEditEtapa &&

                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white' }}>


                        <div style={{ position: 'absolute', top: -20, left: 0, right: 0, margin: "auto" }}>
                            {this.getIcons()}
                        </div>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 20, fontWeight: 500, color: 'black', marginBottom: 0 }}>
                                {this.dictionary.proiecte.creeazaEtape}

                            </h4>

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.proiect !== null &&
                                < div style={{ width: '90%', margin: 'auto' }}>

                                    <GanttProiecteCreateEtapeView
                                        objProiectInfo={this.state.proiect}
                                        dictionary={this.dictionary}
                                        listEtape={this.state.etape}
                                        screenLimit={this.state.windowWidth > 800 ? 30 : (this.state.windowWidth < 600 ? 6 : 12)}
                                        listTaskuri={[]}
                                        changeView={this.changeViewEtape}
                                        goToTask={this.goToTaskView}
                                        insertEtapa={() => { this.setState({ isOpenEtapaInsert: true }) }}
                                        listSubTaskuri={[]}
                                        useri={this.state.useriProiect}
                                        showTag={this.showTag}
                                        hideTag={this.hideTag}
                                        showUserTag={this.showUserTag}
                                        hideUserTag={this.hideUserTag}

                                    />
                                </div>
                            }
                        </Grid>

                        {this.state.proiect !== null &&
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <h5 style={{ textAlign: 'center', marginBottom: 40, fontWeight: 400, color: 'gray' }}> <span style={{ fontWeight: 600 }}>{this.dictionary.proiecte.perioadaProiectului}</span> {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_dela)} - {new Utils().dataPrescurtataRomana(this.state.proiect[0].perioada_panala)}</h5>
                            </Grid>
                        }


                        {/* {this.state.etape} */}
                        <ListEtapeAddProiect
                            etape={this.state.etape}
                            updateEtapa={this.openUpdateEtapa}
                            deleteEtapa={this.deleteEtapa}

                        />

                        <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Button
                               style={{ backgroundColor: '#07B14B', fontSize:14, fontWeight:400, boxShadow:'none' }}
                                variant="contained"
                                className='next-step-projects'
                                color="primary" onClick={this.openInsertEtapa}>
                                {this.dictionary.proiecte.addEtapa}
                            </Button>
                        </Grid>

                    </Grid>
                }

                <Grid container style={{ marginTop: 40, textAlign: 'left' }}>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button
                               style={{ backgroundColor: '#07B14B', fontSize:14, fontWeight:400, boxShadow:'none' }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToInfoBuget}>
                            {this.dictionary.proiecte.step4Projects}
                        </Button>
                    </Grid>

                    <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button
                            style={{ backgroundColor: 'gray', color: 'white',  fontSize:14, fontWeight:400, boxShadow:'none'  }}
                            variant="contained"
                            className='next-step-projects'
                            color="primary" onClick={this.props.goToUtilizatori}>
                            {this.dictionary.proiecte.stepBack}
                        </Button>
                    </Grid>
                </Grid>

                <ProjectDateChange
                    open={this.state.showCalendars}
                    dialogClose={() => { this.setState({ showCalendars: false }) }}
                    changeDataInceput={(ev) => { this.setState({ dtStartDate: ev }) }}
                    dtStartDate={this.state.dtStartDate}
                    changeDataSfarsit={(ev) => { this.setState({ dtFinishDate: ev }) }}
                    dtFinishDate={this.state.dtFinishDate}
                    dictionary={this.dictionary} />

            </div >
        );
    }
}